<template>
  <viewer
    ref="viewer"
    :options="defaultOptions"
    :images="images"
    @inited="inited"
  >
    <img v-show="false" v-for="(src, index) in images" :src="src" :key="index" />
  </viewer>
</template>
<script>
export default {
  name: "PreviewPicture",
  props: {
    images: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      defaultOptions: {
        title: false,
        zIndex: 9999,
      }
    };
  },
  methods: {
    inited(viewer) {
      this.$viewer = viewer;
    },
    async show(index = 0) {
      await this.$nextTick()
      this.$viewer.view(index);
    }
  }
};
</script>
<style lang="less" >
.viewer-canvas {
  // width: 90%;
  // height: 90%;
  // top: 100px;
  img {
    // margin: 0 !important;
    // position: absolute !important;
    // top: 50% !important;
    // left: 50% !important;
    // transform: translate(-50%,-50%) !important;
  }
}
.viewer-close {
  width: 60px !important;
  height: 60px !important;
  background: #fff !important;
  right: 50px !important;
  top: 100px !important;
  &::before{
    // width: 36px;
    // height: 36px;
    background-position: center !important;
    background-size: 100% !important;
    background-image: url('/static/img/view_close.png') !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
  }
  &:hover {
    background: #fff !important;
  }
}
.viewer-toolbar > ul > li:focus, .viewer-toolbar > ul > li:hover {
    background: rgb(14, 143, 106) !important;
}
.viewer-toolbar > ul > li {
  background: rgb(94, 182, 157) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/previewPicture/index.vue